
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"42.148","height":"42.129"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Groupe 1461","transform":"translate(-14767 4623.065)"}},[_c('rect',{attrs:{"data-name":"Rectangle 60","width":"42.148","height":"42.129","rx":"5","transform":"translate(14767 -4623.065)","fill":"#e5ecf0"}}),_c('path',{attrs:{"data-name":"Tracé 6772","d":"M14796.822-4608.148l-2.6-2.6a2.206 2.206 0 00-3.115 0l-11.184 11.208a.747.747 0 00-.2.392l-1.03 5.69a.663.663 0 00.2.638.7.7 0 00.638.2l5.69-1.03a.85.85 0 00.392-.2l11.209-11.208a2.176 2.176 0 000-3.09zm-6.745.515l1.3 1.3-8 8-1.3-1.3zm-9.761 13.391l.785-4.317 3.532 3.532zm5.4-1.766l-1.3-1.3 8-8 1.3 1.3zm10.08-10.08l-1.03 1.03-3.659-3.609 1.03-1.03a.711.711 0 011.03 0l2.6 2.6a.7.7 0 01.025 1.009z","fill":"#044370"}})])])
          )
        }
      }
    